"use strict";
/**
 * AngularJS icon interfaces.
 *
 * @packageDocumentation
 * @module Icon
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Base implementation of an icon configuration.
 */
var IMRIconConfiguration = /** @class */ (function () {
    //#region Ctor
    function IMRIconConfiguration(iconName, provider) {
        this.iconName = iconName;
        this.provider = provider;
    }
    //#endregion
    IMRIconConfiguration.prototype.getDevExtremeIconName = function () {
        if (this.provider.getDevExtremeIconName != null) {
            return this.provider.getDevExtremeIconName();
        }
        return null;
    };
    IMRIconConfiguration.prototype.getTemplate = function () {
        if (this.provider.getTemplate != null) {
            return this.provider.getTemplate();
        }
        return null;
    };
    return IMRIconConfiguration;
}());
exports.IMRIconConfiguration = IMRIconConfiguration;
//# sourceMappingURL=icon.interfaces.js.map